import { styled } from 'styled-components';

interface NoDataWrapperProps {
  $compact: boolean;
}

export const NoDataWrapper = styled.div<NoDataWrapperProps>`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: ${({ $compact }) => ($compact ? '280px' : '555px')};
  background: ${({ theme }) => theme.colors.grey00_1};
  padding: ${({ $compact }) => ($compact ? '48px 12px' : '96px 24px')};
  gap: ${({ $compact }) => ($compact ? '12px' : '24px')};

  & > svg {
    max-width: 100%;
  }
`;
